import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * "Baja de Servicio" no es sobre los clientes finales del tenant — es sobre la
 * suscripción SaaS del comercio con Structura. Esta ruta quedaba mal ubicada
 * (mismo mecanismo que Arrepentimiento, que sí es correcto acá). Redirect a
 * la página de plataforma por si el link viejo quedó indexado o guardado.
 */
export const Route = createFileRoute("/market_/$slug/baja-servicio")({
  beforeLoad: () => {
    throw redirect({ to: "/baja-servicio" });
  },
});
